import { __assign, __generator } from "tslib";
import React from 'react';
import { Trans } from 'react-i18next';
import { all, put, call, take, takeEvery, race, select, } from 'redux-saga/effects';
import { URLS, Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { Warning as WarningIllustration } from '@wix/da-ds/pkg/Icons/Confirmations';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { editDeviation } from '../../../redux/deviations/actionCreators';
import { request } from '../../../xhr';
import { isApiError } from '../../../xhr/request';
import { logBiEvent } from '../../../biLogger/redux/saga';
import { DeviationResourceType } from '../../../types/deviation';
import { reduxModuleLoaded, saveTierAsDraft, saveTierAsDraftAndBuyCore, publishTier, deleteTier, updateTier, tierSaveError, tierSaveRedirect, publishDraftTier, } from './actions';
import { pushGlobalConfirmationModal, confirmNo, confirmYes, popModal, } from '../../../Modals/redux/actionCreators';
import { getCurrentUser, getCurrentUserHasCore, } from '../../../publicSession/selectors';
import i18next from 'i18next';
import { putErrorNotification } from '../../../utils/saga';
import s from './tierPopupSaga.scss';
var logger = ddt.createLogger('tierpopup');
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        logger.log('faking the response!');
        var deviationsByType = require('@wix/da-sample-data').deviationsByType; // eslint-disable-line global-require
        return __assign(__assign({}, deviationsByType.tiers[0]), ((options === null || options === void 0 ? void 0 : options.data) || {}));
    }
}
function handleSaveTier(_a) {
    var title = _a.title, description = _a.description, price = _a.price, benefits = _a.benefits, tags = _a.tags, accessSettings = _a.accessSettings, matureContent = _a.matureContent, coverImage = _a.coverImage, _b = _a.showSubscriberCount, showSubscriberCount = _b === void 0 ? false : _b, messageTitle = _a.messageTitle, messageText = _a.messageText, _c = _a.tierId, tierId = _c === void 0 ? undefined : _c, discordRoles = _a.discordRoles;
    var isUpdate = !!tierId;
    var url = isUpdate ? '/tier/update' : '/tier/create';
    var method = 'post';
    var isMature = matureContent !== undefined && matureContent !== 'safe';
    var data = {
        title: title,
        description: description,
        price: parseInt(price || '1'),
        display_num_subscribers: showSubscriberCount,
        benefits: benefits,
        tags: tags,
        access_settings: accessSettings,
        thank_message_title: messageTitle,
        thank_message_body: messageText,
        cover_image_deviation_id: coverImage === null || coverImage === void 0 ? void 0 : coverImage.deviationId,
        is_mature: isMature,
        mature_level: (isMature ? matureContent : undefined),
        discord_role_ids: discordRoles,
    };
    if (isUpdate) {
        data = __assign(__assign({}, data), { tierid: tierId });
    }
    return call(request, {
        method: method,
        url: url,
        data: data,
    }, fakeResponse);
}
function logBiForTierSave(evid, actionPayload) {
    var deviationId = actionPayload.deviationId, showSubscriberCount = actionPayload.showSubscriberCount, accessSettings = actionPayload.accessSettings;
    return logBiEvent({
        evid: evid,
        itemid: deviationId,
        typeid: deviationId ? DeviationResourceType.TIER : undefined,
        display_subscribers: showSubscriberCount ? 1 : 0,
        access_settings: accessSettings,
    });
}
function publishTierSaga(action) {
    var tierId, createOrUpdateResponse, data, response, currentUser;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, call(logBiForTierSave, BiEventType.TIER_PUBLISH, action.payload)];
            case 1:
                _c.sent();
                tierId = action.payload.tierId;
                logger.log('payload', action.payload);
                return [4 /*yield*/, handleSaveTier(action.payload)];
            case 2:
                createOrUpdateResponse = _c.sent();
                if (!!createOrUpdateResponse) return [3 /*break*/, 5];
                return [4 /*yield*/, putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'))];
            case 3:
                _c.sent();
                return [4 /*yield*/, put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')))];
            case 4:
                _c.sent();
                return [2 /*return*/];
            case 5:
                if (!isApiError(createOrUpdateResponse)) return [3 /*break*/, 8];
                return [4 /*yield*/, putErrorNotification(createOrUpdateResponse.errorDescription)];
            case 6:
                _c.sent();
                return [4 /*yield*/, put(tierSaveError(createOrUpdateResponse.errorDescription))];
            case 7:
                _c.sent();
                return [2 /*return*/];
            case 8:
                if (!!((_b = (_a = createOrUpdateResponse === null || createOrUpdateResponse === void 0 ? void 0 : createOrUpdateResponse.deviation) === null || _a === void 0 ? void 0 : _a.tier) === null || _b === void 0 ? void 0 : _b.tierId)) return [3 /*break*/, 11];
                return [4 /*yield*/, putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'))];
            case 9:
                _c.sent();
                return [4 /*yield*/, put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')))];
            case 10:
                _c.sent();
                return [2 /*return*/];
            case 11:
                tierId = createOrUpdateResponse.deviation.tier.tierId;
                data = {
                    tierid: tierId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/tier/publish',
                        data: data,
                    })];
            case 12:
                response = _c.sent();
                if (!!response) return [3 /*break*/, 15];
                return [4 /*yield*/, putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'))];
            case 13:
                _c.sent();
                return [4 /*yield*/, put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')))];
            case 14:
                _c.sent();
                return [2 /*return*/];
            case 15:
                if (!isApiError(response)) return [3 /*break*/, 18];
                return [4 /*yield*/, putErrorNotification(response.errorDescription)];
            case 16:
                _c.sent();
                return [4 /*yield*/, put(tierSaveError(response.errorDescription))];
            case 17:
                _c.sent();
                return [2 /*return*/];
            case 18: return [4 /*yield*/, put(tierSaveRedirect())];
            case 19:
                _c.sent();
                window.location.reload();
                return [4 /*yield*/, select(getCurrentUser)];
            case 20:
                currentUser = _c.sent();
                window.location.href = "".concat(Url.userSubscriptionsPath({
                    username: currentUser.username,
                    tierDeviationId: tierId,
                }), "?tier-publish-success=1");
                return [2 /*return*/];
        }
    });
}
function publishDraftTierSaga(action) {
    var deviation, deviationId, data, response, currentUser;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(logBiForTierSave, BiEventType.TIER_PUBLISH, action.payload)];
            case 1:
                _b.sent();
                deviation = action.payload;
                deviationId = deviation.deviationId;
                data = {
                    tierid: deviationId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/tier/publish',
                        data: data,
                    })];
            case 2:
                response = _b.sent();
                if (!(!response || isApiError(response))) return [3 /*break*/, 4];
                return [4 /*yield*/, put(editDeviation({ deviation: deviation }))];
            case 3:
                _b.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, put(tierSaveRedirect())];
            case 5:
                _b.sent();
                return [4 /*yield*/, select(getCurrentUser)];
            case 6:
                currentUser = _b.sent();
                window.location.href = "".concat(Url.userSubscriptionsPath({
                    username: currentUser.username,
                    tierDeviationId: (_a = response === null || response === void 0 ? void 0 : response.deviation) === null || _a === void 0 ? void 0 : _a.deviationId,
                }), "?tier-publish-success=1");
                return [2 /*return*/];
        }
    });
}
function updateTierSaga(action) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(logBiForTierSave, BiEventType.TIER_UPDATE, action.payload)];
            case 1:
                _a.sent();
                return [4 /*yield*/, handleSaveTier(action.payload)];
            case 2:
                response = _a.sent();
                if (!!response) return [3 /*break*/, 5];
                return [4 /*yield*/, putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'))];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')))];
            case 4:
                _a.sent();
                return [2 /*return*/];
            case 5:
                if (!isApiError(response)) return [3 /*break*/, 8];
                return [4 /*yield*/, putErrorNotification(response.errorDetails || response.errorDescription)];
            case 6:
                _a.sent();
                return [4 /*yield*/, put(tierSaveError(response.errorDescription))];
            case 7:
                _a.sent();
                return [2 /*return*/];
            case 8: return [4 /*yield*/, put(tierSaveRedirect())];
            case 9:
                _a.sent();
                window.location.reload();
                return [2 /*return*/];
        }
    });
}
function saveTierDraftSaga(action) {
    var deviationId, currentUserHasCore, no, response, currentUser;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                deviationId = action.payload.deviationId;
                return [4 /*yield*/, select(getCurrentUserHasCore)];
            case 1:
                currentUserHasCore = _a.sent();
                return [4 /*yield*/, call(logBiForTierSave, BiEventType.TIER_SAVE_AS_DRAFT, action.payload)];
            case 2:
                _a.sent();
                if (!(action.type === saveTierAsDraft.toString())) return [3 /*break*/, 6];
                return [4 /*yield*/, put(pushGlobalConfirmationModal({
                        titleTransKey: 'tierPopup.saveConfirmation.title',
                        textTransKey: currentUserHasCore
                            ? 'tierPopup.saveConfirmation.text'
                            : 'tierPopup.saveConfirmation.text.nonCore',
                        cancelBtnLabelTransKey: 'tierPopup.saveConfirmation.button.cancel',
                        confirmBtnLabelTransKey: 'tierPopup.saveConfirmation.button.confirm',
                        confirmBtnBiData: {
                            evid: BiEventType.TIER_SAVE_AS_DRAFT_CONFIRM,
                            typeid: deviationId ? DeviationResourceType.TIER : undefined,
                            itemid: deviationId,
                            display_subscribers: action.payload.showSubscriberCount ? 1 : 0,
                            access_settings: action.payload.accessSettings,
                        },
                        icon: React.createElement(WarningIllustration, null),
                        closeOnConfirmation: false,
                    }))];
            case 3:
                _a.sent();
                return [4 /*yield*/, race({
                        yes: take(confirmYes),
                        no: take(confirmNo),
                    })];
            case 4:
                no = (_a.sent()).no;
                if (!no) return [3 /*break*/, 6];
                return [4 /*yield*/, put(popModal())];
            case 5:
                _a.sent();
                return [2 /*return*/];
            case 6:
                logger.log('saving', action.payload);
                return [4 /*yield*/, handleSaveTier(action.payload)];
            case 7:
                response = _a.sent();
                if (!!response) return [3 /*break*/, 10];
                return [4 /*yield*/, putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'))];
            case 8:
                _a.sent();
                return [4 /*yield*/, put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')))];
            case 9:
                _a.sent();
                return [2 /*return*/];
            case 10:
                if (!isApiError(response)) return [3 /*break*/, 13];
                return [4 /*yield*/, putErrorNotification(response.errorDescription)];
            case 11:
                _a.sent();
                return [4 /*yield*/, put(tierSaveError(response.errorDescription))];
            case 12:
                _a.sent();
                return [2 /*return*/];
            case 13:
                if (!(action.type === saveTierAsDraft.toString())) return [3 /*break*/, 16];
                return [4 /*yield*/, put(tierSaveRedirect())];
            case 14:
                _a.sent();
                return [4 /*yield*/, select(getCurrentUser)];
            case 15:
                currentUser = _a.sent();
                window.location.href = Url.userSubscriptionsPath({
                    username: currentUser.username,
                });
                return [3 /*break*/, 18];
            case 16:
                if (!(action.type === saveTierAsDraftAndBuyCore.toString())) return [3 /*break*/, 18];
                return [4 /*yield*/, put(tierSaveRedirect())];
            case 17:
                _a.sent();
                window.location.href = URLS.CORE_MEMBERSHIP;
                _a.label = 18;
            case 18: return [2 /*return*/];
        }
    });
}
function deleteTierSaga(action) {
    var tierid, hasSubscribers, isDraft, textTranslationKey, textTranslationCmp, no, data, response, currentUser;
    var _a, _b, _c, _d, _e, _f, _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                tierid = (_c = (_b = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.deviation) === null || _b === void 0 ? void 0 : _b.tier) === null || _c === void 0 ? void 0 : _c.tierId;
                if (!!tierid) return [3 /*break*/, 3];
                return [4 /*yield*/, putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'))];
            case 1:
                _h.sent();
                return [4 /*yield*/, put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')))];
            case 2:
                _h.sent();
                return [2 /*return*/];
            case 3:
                hasSubscribers = ((_f = (_e = (_d = action.payload.deviation.tier) === null || _d === void 0 ? void 0 : _d.stats) === null || _e === void 0 ? void 0 : _e.subscribers) !== null && _f !== void 0 ? _f : 0) > 0;
                isDraft = ((_g = action.payload.deviation.tier) === null || _g === void 0 ? void 0 : _g.state) === 'draft';
                textTranslationKey = isDraft
                    ? 'tierPopup.deleteConfirmation.draft.text'
                    : hasSubscribers
                        ? 'tierPopup.deleteConfirmation.published.hasSubscribers.text'
                        : 'tierPopup.deleteConfirmation.published.noSubscribers.text';
                textTranslationCmp = function () { return (React.createElement("div", null,
                    React.createElement(Trans, { i18nKey: textTranslationKey },
                        "New subscribers won\u2019t be able to join. Content not associated with a different tier will become visible to all.",
                        React.createElement(PlainButtonOrLink, { href: "https://www.deviantartsupport.com/en/article/how-do-i-edit-or-delete-a-tier", target: "_blank", className: s['modal-link'] }, "Learn more about deleting tiers")))); };
                return [4 /*yield*/, put(pushGlobalConfirmationModal({
                        titleTransKey: isDraft
                            ? 'tierPopup.deleteConfirmation.draft.title'
                            : 'tierPopup.deleteConfirmation.published.title',
                        textComponent: textTranslationCmp,
                        cancelBtnLabelTransKey: 'tierPopup.deleteConfirmation.button.cancel',
                        confirmBtnLabelTransKey: 'tierPopup.deleteConfirmation.button.confirm',
                        confirmBtnBiData: {
                            evid: BiEventType.TIER_DELETE_CONFIRM,
                            typeid: DeviationResourceType.TIER,
                            itemid: action.payload.deviation.deviationId,
                            has_subscribers: hasSubscribers ? 1 : 0,
                        },
                        icon: React.createElement(WarningIllustration, null),
                        closeOnConfirmation: false,
                    }))];
            case 4:
                _h.sent();
                return [4 /*yield*/, race({
                        yes: take(confirmYes),
                        no: take(confirmNo),
                    })];
            case 5:
                no = (_h.sent()).no;
                if (!no) return [3 /*break*/, 7];
                return [4 /*yield*/, put(popModal())];
            case 6:
                _h.sent();
                return [2 /*return*/];
            case 7:
                logger.log('deleting', tierid);
                data = {
                    tierid: tierid,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: "/tier/delete",
                        data: data,
                    }, fakeResponse)];
            case 8:
                response = _h.sent();
                if (!!response) return [3 /*break*/, 11];
                return [4 /*yield*/, putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'))];
            case 9:
                _h.sent();
                return [4 /*yield*/, put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')))];
            case 10:
                _h.sent();
                return [2 /*return*/];
            case 11:
                if (!isApiError(response)) return [3 /*break*/, 14];
                return [4 /*yield*/, putErrorNotification(response.errorDescription)];
            case 12:
                _h.sent();
                return [4 /*yield*/, put(tierSaveError(response.errorDescription))];
            case 13:
                _h.sent();
                return [2 /*return*/];
            case 14: return [4 /*yield*/, put(tierSaveRedirect())];
            case 15:
                _h.sent();
                return [4 /*yield*/, select(getCurrentUser)];
            case 16:
                currentUser = _h.sent();
                window.location.href = Url.userSubscriptionsPath({
                    username: currentUser.username,
                });
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, take(reduxModuleLoaded)];
            case 1:
                _a.sent(); // wait for redux to load
                return [4 /*yield*/, all([
                        takeEvery(saveTierAsDraft, saveTierDraftSaga),
                        takeEvery(saveTierAsDraftAndBuyCore, saveTierDraftSaga),
                        takeEvery(publishTier, publishTierSaga),
                        takeEvery(publishDraftTier, publishDraftTierSaga),
                        takeEvery(deleteTier, deleteTierSaga),
                        takeEvery(updateTier, updateTierSaga),
                    ])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=tierPopupSaga.js.map